import { useCallback } from "react";

export function useLootspotImportExport({ setMarkers, setNotification }) {
  // Import markera
  const handleImportLootspot = useCallback(
    (data) => {
      setMarkers((markers) => {
        const updated = [...markers];
        data.forEach((newMarker) => {
          const index = updated.findIndex((m) => m.id === newMarker.id);
          if (index !== -1) {
            updated[index] = { ...updated[index], ...newMarker };
          } else {
            updated.push(newMarker);
          }
        });
        return updated;
      });
      setNotification("Lootspots imported successfully!");
    },
    [setMarkers, setNotification],
  );

  // Masovni unos/izmene
  const handleApplyMassLootspot = useCallback(
    (updates) => {
      setMarkers((markers) => {
        // Samo update-uj postojeće markere bez resetovanja
        let updatedMarkers = markers.map((m) => (updates[m.id] ? { ...m, ...updates[m.id] } : m));
        // Dodaj nove markere koji ne postoje
        Object.entries(updates).forEach(([id, changes]) => {
          if (!updatedMarkers.some((m) => m.id === id)) {
            updatedMarkers.push({
              id,
              x: changes.x ?? 0.5,
              y: changes.y ?? 0.5,
              size: changes.size ?? 1,
              markerName: changes.markerName ?? "",
              map: changes.map ?? "",
              team: changes.team ?? "",
              logo: changes.logo ?? "",
              tier: changes.tier ?? "",
              flag: changes.flag ?? "",
              slot: changes.slot ?? "",
            });
          }
        });
        // FORSIRAJ update svih markera (trigger re-render)
        return [...updatedMarkers];
      });
      setNotification("Bulk lootspot update applied!");
    },
    [setMarkers, setNotification],
  );

  return { handleImportLootspot, handleApplyMassLootspot };
}
